import request from '@/utils/request'

export default {
    deleteMeeting: function (data) {
        return request({
            url: '/zf/deleteMeeting',
            method: 'post',
            data: data
        })
    },
    getUserNameById: function(ids){
        return request({
            url: '/zf/getUserNameById',
            method: 'get',
            params: {
                "ids": ids,
           },
        })
    },

    queryCheckList: function (data) {
        return request({
            url: '/zf/queryCheckList',
            method: 'post',
            data: data
        })
    },

    addCheck: function (data) {
        return request({
            url: '/zf/addCheck',
            method: 'POST',
            data: data
        })
    },
           //文件
           exportFile:function(path){
            return request({
                url: '/zf/downloadReportFile',
                headers: { 'Content-Type': 'application/x-www-form-urlencoded'},
                method: 'get',
                responseType: 'blob',
                params: {  
                   "fileUrl" : path
                    },
                
            })
    
        },
    getCheckByCId: function(checkId){
            return request({
                url: '/zf/getCheckByCId',
                method: 'get',
                params: {
                    "checkId": checkId,
               },
            })
        },
    getPlanByCId: function(planId){
        return request({
            url: '/zf/getPlanByCId',
            method: 'get',
            params: {
                "planId": planId,
           },
        })
    },
    // 人员培训/安委会会议
    queryPlanList: function (data) {
        return request({
            url: '/zf/queryPlanList',
            method: 'post',
            data: data
        })
    },
    addPlan: function (data) {
        return request({
            url: '/zf/addPlan',
            method: 'POST',
            data: data
        })
    },

    getGroupByUserid: function(userid){
        return request({
            url: '/zf/getGroupByUserid',
            //headers: { 'Content-Type': 'application/x-www-form-urlencoded'},
            method: 'get',
            params: {
                "userid": userid,
               
             
           },
        })
    },
    
    forWordOut3D: function (c_id) {
        return request({
            url: '/zf/forWordOut3D',
            method: 'get',
            params:{
                'c_id':c_id,
            }
        })
    },



        // 质量上报
        rereportYHSB: function(data){
            return request({
                url: '/zf/rereportYHSB',
                //headers: { 'Content-Type': 'application/x-www-form-urlencoded'},
                method: 'post',
                data: data
            })
        },
    
    getWhereInfoList:function(){
        return request({
            url: '/zf/getWhereInfoList',
            //headers: { 'Content-Type': 'application/x-www-form-urlencoded'},
            method: 'get',
            //params: { 'type': type }
        })
    },

    getCatalogList:function(){
        return request({
            url: '/zf/getCatalogList',
            //headers: { 'Content-Type': 'application/x-www-form-urlencoded'},
            method: 'get',
            //params: { 'type': type }
        })
    },


    
    getNewmeetingId:function(){
        return request({
            url: '/zf/getNewmeetingId',
            //headers: { 'Content-Type': 'application/x-www-form-urlencoded'},
            method: 'get',
            //params: { 'type': type }
        })
    },
    
    getGroup1: function(){
        return request({
            url: '/zf/getGroup',
            //headers: { 'Content-Type': 'application/x-www-form-urlencoded'},
            method: 'get',
            //params: { 'type': type }
        })
    },
    
    confirmTrainMsg: function (data) {
        return request({
            url: '/zf/confirmTrainMsg',
            method: 'post',
            data: data
        })
    },


    groupList: function(){
        return request({
            url: '/zf/groupList',
            //headers: { 'Content-Type': 'application/x-www-form-urlencoded'},
            method: 'get',
            // params: {
            //     "userPhone": userPhone,
            //     "api":"get_history_meeting_messages"
             
            //  },
        })
    },


}


// WEBPACK FOOTER //
// ./src/api/zf.js